module.exports = __webpack_public_path__ + "images/common/logoOclock.303b8759.svg";